/* eslint-disable no-unused-vars */
/* eslint-disable prefer-const */
import React from 'react';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import SearchIcon from '@material-ui/icons/Search';
import EditIcon from '@material-ui/icons/Edit';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import Icon from '@material-ui/core/Icon';

import { fetchEmployee, fetchEmployeeConfigs, fetchEmployees, applyRestrictions } from '../../store/actions/employee';
import { fetchLocations } from '../../store/actions/location';
import { fetchSchedules } from '../../store/actions/schedule';
import { fetchHoursSets } from '../../store/actions/hoursSets';


import ContentHeader from '../../components/ContentHeader/ContentHeader';
import SelectTable from '../../components/DataTable/SelectTable';

import BankHoursConfig from './components/BankHoursConfig';
import ScheduleConfig from './components/ScheduleConfig';
import RestrictionsConfig from './components/RestrictionsConfig';
import { Typography } from '@material-ui/core';

const styles = theme => ({
  input: {
    width: '40%',
    margin: theme.spacing(3),
  },
  paper: {
    margin: theme.spacing(4),
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
  },
  dialog: {
    display: 'flex',
    margin: 'auto',
    width: 'fit-content',
  },

  dialogContent: {
  },

});

class ApplyRestrictions extends React.Component {
  state = {
    newHasBlockedDevice: '',
    selected: [],
    searchQuery: '',
    openModal: null,
    openEscale: null,
    openBank: null,
    openRestrict: null,
    startDate: '',
    restrictData: null,
    bankHoursData: null,
  };

  componentDidMount() {
    this.fetchData();
    // this.props.onFetcHoursSets();
  }


  fetchData = () => {
    this.props.onFetchEmployees();
    this.props.onFetchLocations();
    this.props.onFetchSchedules();
  }

  handleEditClick = () => {
    this.setState({ openModal: true });
  };

  handleEditCancel = () => {
    this.setState({ openModal: false });
  };

  handleNewHasBlockedDevice = (value) => {
    if (value == 'MOBILE_ONLY'){
      this.setState({ newHasBlockedDevice: value });
    }else if(value == 'WEB_ONLY'){
      this.setState({ newHasBlockedDevice: value });
    }else{
      this.setState({ newHasBlockedDevice: '' });
    }
  };

  handleInputChange = name => (event) => {
    this.setState({ [name]: event.target.value });
  };

  handleMenu = (event) => {
    this.setState({ openModal: event.currentTarget });
  }

  handleOpenEscale = () => {
    if (this.state.selected.length === 1) {
      this.props.onFetchEmployeeConfig(this.state.selected[0])
        .then((res) => {
          this.setState({
            scheduleData: {
              scheduleId: res.workSchedule.workScale,
              scheduleStartDate: res.workSchedule.dtRef,
            },
            openEscale: true,
          });
        });
    } else {
      this.setState({
        openEscale: true,
        scheduleData: {},
        bankHoursData: {},
        restrictData: {},
      });
    }
  }

  handleCloseEscale = () => {
    this.fetchData();
    this.setState({ openEscale: false });
  }

  handleOpenBank = () => {
    if (this.state.selected.length === 1) {
      this.props.onFetchEmployeeConfig(this.state.selected[0])
        .then((res) => {
          this.setState({
            bankHoursData: {
              hasBankOfHours: !!res.bankHours.id,
              initialValue: res.bankHours.initialValue,
              dtTo: res.bankHours.dtTo,
              dtFrom: res.bankHours.dtFrom,
              cumulativeHoursLimit: res.bankHours.cumulativeHoursLimit,
            },
            openBank: true,
          });
        });
    } else {
      this.setState({
        openBank: true,
        scheduleData: {},
        bankHoursData: {},
        restrictData: {},
      });
    }
  }

  handleCloseBank = () => {
    this.fetchData();
    this.setState({ openBank: false });
  }

  handleOpenRestrict = () => {
    if (this.state.selected.length === 1) {
      this.props.onFetchEmployeeConfig(this.state.selected[0])
        .then((res) => {
          this.setState({
            restrictData: {
              dtRef: res.restrictions.restrictByLocation == false && res.restrictions.hasPhoto == false && res.restrictions.hasRestrictDevice == false? '' : res.restrictions.dtRef,
              restrictByLocation: res.restrictions.restrictByLocation,
              hasPhoto: res.restrictions.hasPhoto,
              locations: res.restrictions.restrictByLocation && res.allowedLocations ? JSON.parse(res.allowedLocations).map(item => item.id) : [],
              hasBlockedDevice: res.restrictions.hasBlockedDevice ? {
                hasRestrictDevice: res.restrictions.hasRestrictDevice,
                hasBlockedDevice: res.restrictions.hasBlockedDevice,
                listBlockedDevice: res.restrictions.listBlockedDevice ? res.restrictions.listBlockedDevice : [],
              } : {}
            },
            openRestrict: true,
          });
        });
    } else {
      this.setState({
        openRestrict: true,
        scheduleData: {},
        bankHoursData: {},
        restrictData: {},
      });
    }
  }
  
  handleCloseRestrict = () => {
    this.fetchData();
    this.setState({ openRestrict: false });
  }


  handleSelectAll = (event, checked, searchSelect) => {
    const searchIndex = searchSelect.map(employee => employee.id);
    // console.log('selected',searchSelect)
    if (checked) {
      const newSelected = this.state.selected.slice();

      if (searchIndex) {
        if (this.state.selected.indexOf(searchIndex[0]) === -1) {
          this.props.employees.map(employee =>
          (searchIndex.indexOf(employee.id) > -1 && newSelected.indexOf(employee.id) === -1
            ? newSelected.push(employee.id)
            : null));
        } else {
          this.props.employees.map(employee =>
          (searchIndex.indexOf(employee.id) > -1
            ? newSelected.splice(newSelected.indexOf(employee.id), 1)
            : null));
        }
      }

      this.setState({ selected: newSelected });
    } else if (searchIndex.length === this.props.employees.length) {
      this.setState({ selected: [] });
    } else {
      const newSelected = this.state.selected.slice();
      this.props.employees.map(employee =>
      (searchIndex.indexOf(employee.id) > -1
        ? newSelected.splice(newSelected.indexOf(employee.id), 1)
        : null));

      this.setState({ selected: newSelected });
    }
  };

  handleSelect = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    // this.setState({ selected: this.props.employees.filter(e => e.id === newSelected[0]) });

    this.setState({ selected: newSelected });
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  render() {
    const {
      classes, employees, locations, schedules, onApplyRestrictions, loading, hoursSets,
      handleBlur,
    } = this.props;
    const {
      openModal, selected, searchQuery, startDate,
    } = this.state;


    const columns = [
      { name: 'customName', label: 'Nome' },
      { name: 'department', label: 'Departamento' },
      { name: '_workingDay', label: 'Escala' },
      { name: '_optBankHours', label: 'Banco de Horas' },
      { name: 'restrictions', label: 'Restrições' },
      // { name: '_optSet', label: 'Set' },
    ];

    employees.map((e) => {
      for (const [key, value] of Object.entries(e)) {
        if ((
          key === '_optBankHours' ||
          // key === '_workingDay' ||
          key === '_hasPhoto' ||
          key === '_restrictByLocation')
          && value === null) {
          e[key] = false;
        }
      }
      return e;
    });

    let employeesInfo = [...employees];
    employeesInfo.forEach((employee) => {
      if (employee.hasAplicationsFutures) {
        employee.customName = (
          <span style={{ alignItems: 'center', display: 'flex' }}>
            {employee.name}
            <Tooltip title="Possui aplicações futuras" aria-label="Possui aplicações futuras" placement="top">
              <Icon style={{ color: '#537ccd', marginLeft: '6px' }}>
                timelapse
              </Icon>
            </Tooltip>
          </span>
        );
      } else {
        employee.customName = employee.name;
      }
    });

    const searchFields = ['name', '_office', 'department'];

    return (
      <React.Fragment>
        <ContentHeader
          title="Configurações"
          subtitle="Selecione os funcionários para aplicar configurações de escala, banco de horas e restrições"
        >
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleMenu}
          // disabled={!selected.length}
          >
            <EditIcon /> Editar
          </Button>
        </ContentHeader>

        <Menu
          id="simple-menu"
          anchorEl={openModal}
          keepMounted
          open={this.state.openModal}
          onClose={this.handleEditCancel}
        >
          {selected.length === 0 ? (<Typography style={{ padding: '5px' }}>Selecione um ou mais Funcionários</Typography>) : ""}
          <MenuItem disabled={!selected.length} onClick={this.handleOpenEscale}>Escala de Trabalho</MenuItem>
          <MenuItem disabled={!selected.length} onClick={this.handleOpenBank}>Banco de Horas</MenuItem>
          <MenuItem disabled={!selected.length} onClick={this.handleOpenRestrict}>Restrições</MenuItem>
        </Menu>

        <ScheduleConfig
          open={this.state.openEscale}
          close={this.handleCloseEscale}
          schedules={schedules}
          data={this.state.scheduleData || []}
          employee={this.state.selected}
          employees={employees}

        />

        <BankHoursConfig
          open={this.state.openBank}
          close={this.handleCloseBank}
          selected={this.state.selected}
          employee={this.state.selected}
          data={this.state.bankHoursData || []}
          employees={employees}
        />

        <RestrictionsConfig
          state={this.state}
          handleNewHasBlockedDevice={this.handleNewHasBlockedDevice}
          open={this.state.openRestrict}
          close={this.handleCloseRestrict}
          locations={locations}
          employee={this.state.selected}
          data={this.state.restrictData || []}
          employees={employees}
        />

        <Paper elevation={2}>
          <TextField
            className={classes.input}
            value={searchQuery}
            onChange={this.handleInputChange('searchQuery')}
            placeholder="Buscar"
            type="text"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="disabled" />
                </InputAdornment>
              ),
            }}
          />

          <SelectTable
            rows={employees}
            columns={columns}
            loading={loading}
            searchFields={searchFields}
            onSelect={this.handleSelect}
            onSelectAll={this.handleSelectAll}
            checkSelect={this.isSelected}
            numSelected={selected.length}
            searchQuery={searchQuery.toUpperCase()}
          />
        </Paper>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state =>
({
  loading: state.general.loading,
  employees: state.employee.employees,
  locations: state.location.locations,
  schedules: state.schedule.schedules.map(schedule => schedule.workingDay),
  hoursSets: state.hoursSets.hoursSets,
});

const mapDispatchToProps = dispatch => ({
  onFetchEmployees: () => dispatch(fetchEmployees()),
  onFetchLocations: () => dispatch(fetchLocations()),
  onFetchSchedules: () => dispatch(fetchSchedules()),
  onFetcHoursSets: () => dispatch(fetchHoursSets()),
  onFetchEmployeeConfig: id => dispatch(fetchEmployeeConfigs(id)),

  onApplyRestrictions: restrictions => dispatch(applyRestrictions(restrictions)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ApplyRestrictions));
